import axios from 'axios';
import { ApplicationVersion } from '@/types/version';

const API_BASE_URL = import.meta.env.VITE_API_URL;

export interface CreateVersionRequest {
  version: string;
  description?: string;
  isForceUpdate: boolean;
}

export const versionApi = {
  getLatest: async (): Promise<ApplicationVersion | null> => {
    try {
      const response = await axios.get(`${API_BASE_URL}/application-versions/latest`);
      return response.data;
    } catch (error) {
      console.error('Failed to get latest version:', error);
      return null;
    }
  },

  getAll: async (): Promise<ApplicationVersion[]> => {
    try {
      const response = await axios.get(`${API_BASE_URL}/application-versions`);
      return response.data;
    } catch (error) {
      console.error('Failed to get versions:', error);
      return [];
    }
  },

  create: async (data: CreateVersionRequest, token: string): Promise<ApplicationVersion> => {
    const response = await axios.post(
      `${API_BASE_URL}/application-versions`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  },

  delete: async (id: number, token: string): Promise<void> => {
    await axios.delete(`${API_BASE_URL}/application-versions/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};

